import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import msalPlugin  from "./plugins/msalPlugin";
import { myMSALObj, tokenRequest, loginRequest } from "./authConfig";
import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "./router/NavigationClient";

Vue.config.productionTip = false
Vue.prototype.$authenticated = false
Vue.prototype.$roles = [];
Vue.prototype.$aviso = {mensaje:"",mostrar:false,tipo:""}
Vue.prototype.$esperar = (ms:number) => new Promise(resolve => setTimeout(resolve, ms));


const navigationClient = new CustomNavigationClient(router);
myMSALObj.setNavigationClient(navigationClient);

const accounts = myMSALObj.getAllAccounts();
if (accounts.length > 0) {
  myMSALObj.setActiveAccount(accounts[0]);
}

myMSALObj.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    myMSALObj.setActiveAccount(account);
  }
});


Vue.use(VueAxios, axios)
Vue.use(msalPlugin,myMSALObj)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
